import axios from "axios";

interface Address {
    line1: string;
    line2: string;
    line3: string;
    line4: string;
    postcode: string;
}

export interface Dealer {
    code: string;
    name: string;
    address: Address;
    phone: string;
    email: string;
    manufacturerCode: string;
    converter: boolean;
    mdpClassification: string;
    status: 'Open' | 'Closed' | 'Closing Down';
}

export async function fetchDealers(endpoint: string): Promise<Dealer[]> {
    const response = await axios({
        timeout: 60000,
        method: "get",
        url: endpoint
    });

    return response.data;
}

export async function changeToDealerCode(endpoint: string, dealerCode: string): Promise<unknown> {
    const response = await axios({
        timeout: 60000,
        method: "post",
        url: endpoint,
        data: {
            dealerCode
        }
    });

    return response.data;
}
